/**
 * Componente: Vista previa de licencia
 * Previsualización interna (no es un documento digital ni tiene QR):
 * le permite al operador chequear que los datos y la foto quedaron bien
 * cargados antes de imprimir, y mostrarle la tarjeta en pantalla al contribuyente.
 * Usa el diseño de marca guardado del municipio (logo + colores); si el
 * municipio no configuró nada, el backend ya devuelve el estándar Betech.
 */

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import LicenseCard from './LicenseCard';
import { IconCerrar, IconAdvertencia } from './icons';
import { useClasesMunicipio } from '../utils/clasesLicencia';
import { clasesSeCortanEnDiseno, useTipografiasListas } from '../utils/formatoClases';
import '../styles/disenador.css';

const API_URL = process.env.REACT_APP_API_URL;

const PadronPreviewModal = ({ contribuyenteId, onClose }) => {
  const [contribuyente, setContribuyente] = useState(null);
  const [diseno, setDiseno] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');
  const { catalogo } = useClasesMunicipio();
  useTipografiasListas();

  useEffect(() => {
    const cargarDatos = async () => {
      try {
        setCargando(true);
        const token = sessionStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };
        const [resContribuyente, resDiseno] = await Promise.all([
          axios.get(`${API_URL}/contribuyentes/${contribuyenteId}`, { headers }),
          axios.get(`${API_URL}/municipios/disenos/activo`, { headers }),
        ]);
        setContribuyente(resContribuyente.data.contribuyente);
        setDiseno(resDiseno.data.diseno);
      } catch (err) {
        console.error('Error al cargar vista previa:', err);
        setError(err.response?.data?.mensaje || 'Error al cargar el contribuyente');
      } finally {
        setCargando(false);
      }
    };

    cargarDatos();
  }, [contribuyenteId]);

  return (
    <div className="modal-overlay">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Vista previa de licencia</h2>
          <button className="modal-close" onClick={onClose}><IconCerrar size={18} /></button>
        </div>

        <div className="modal-form">
          <div className="modal-body">
            {cargando ? (
              <div className="padron-loading">
                <div className="loading-spinner"></div>
                <p>Cargando datos...</p>
              </div>
            ) : error ? (
              <div className="alert alert-error">
                <IconAdvertencia size={18} />
                <p>{error}</p>
              </div>
            ) : (
              <>
              {clasesSeCortanEnDiseno(diseno, contribuyente.clases, catalogo, diseno.tipo_impresion === 'doble_cara' ? 'ambas' : 'frente') && (
                <div className="alert alert-error">
                  <IconAdvertencia size={18} />
                  <p>El texto de las clases no entra completo en este carnet: saldría cortado con "…".</p>
                </div>
              )}
              <div className="license-preview-wrapper">
                {diseno.tipo_impresion === 'doble_cara' ? (
                  <div className="disenador-preview-doble">
                    <div className="disenador-preview-cara">
                      <span className="disenador-preview-cara-label">Frente</span>
                      <LicenseCard contribuyente={contribuyente} diseno={diseno} cara="frente" />
                    </div>
                    <div className="disenador-preview-cara">
                      <span className="disenador-preview-cara-label">Dorso</span>
                      <LicenseCard contribuyente={contribuyente} diseno={diseno} cara="dorso" />
                    </div>
                  </div>
                ) : (
                  <LicenseCard contribuyente={contribuyente} diseno={diseno} />
                )}
              </div>
              </>
            )}
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-cancelar" onClick={onClose}>
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PadronPreviewModal;
